export const DOCS = "https://docs.risechain.com/";

export const RISE_TESTNET_EXPLORER = "https://explorer.testnet.riselabs.xyz/";

export const RISE_GITHUB = "https://github.com/risechain";
